import { APIResult } from 'src/modules/models/api-result';

export class BookingPackageSearchResult extends APIResult {
    data: any = []
    total: number = 0;
}